// Launch feature flags. Flip to true to release a feature across web.
// Kept intentionally simple so re-enabling later is a one-line change.
export const FEATURES = {
  seedBox: false, // Seed Box + its seed-packet scanner (hidden for now)
  pantry: true, // Pantry Planner (free for everyone)
  shop: false, // Boutique Shop + orders/library commerce (hidden until launch)
};
